const loadRest = require('../utils/pagination');

const PagedList = require('../entities/paged-list');

class PaginationHelper {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
    this.loadRest = loadRest(this.client);
  }

  next(pagedList
  /*: PagedList<*>*/
  )
  /*: Promise<PagedList<*>>*/
  {
    const nextRequest = pagedList && pagedList.page && pagedList.page.next;
    if (!nextRequest) throw new Error('Cannot page next on list with no next page');
    return this.client.get(nextRequest);
  }

  prev(pagedList
  /*: PagedList<*>*/
  )
  /*: Promise<PagedList<*>>*/
  {
    const prevRequest = pagedList && pagedList.page && pagedList.page.prev;
    if (!prevRequest) throw new Error('Cannot page previous on list with no previous page');
    return this.client.get(prevRequest);
  }
  /* eslint-disable-next-line class-methods-use-this */


  toJSON() {
    // Not serializable
    return undefined;
  }

}

module.exports = PaginationHelper;